const KEYS = { LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40 };

import _ from 'lodash';
import createjs from 'createjs-collection';
import { getGamePath } from './../../Utils/pathUtils.js';

import * as fJS from './../cjsRoot/fJS';
import { jsColor } from './../cjsRoot/jsColor';
import { cjsGroup } from './../cjsRoot/cjsGroup';
import { cjsItem } from './../cjsRoot/cjsBase';

import STORE from '@/store';

export class cjsMaze extends cjsItem {
  _mask;
  _move;
  _checks;

  constructor(obj) {
    super(obj);
    this._mask = false;
    this._move = false;
    this._checks = false;
  }

  create() {
    super.create();

    if (!this.block) {
      this._stage.groups[this.idGroup].block = false;
      this._stage.groups[this.idGroup].stageMouseDown = this.stageMouseDown;

      if (
        typeof this.otherProperty.maze == 'undefined' ||
        typeof this.otherProperty.maze == null ||
        typeof this.otherProperty.maze.stop == 'undefined' ||
        this.otherProperty.maze.stop == null
      ) {
        throw 'Zdefiniuj kolor zakończenia ';
      }
      this._stage.hero = this;
      if (typeof this.otherProperty.maze.mask != 'undefined' && this.otherProperty.maze.mask != null) {
        let multibookType = this._stage._mixins.multibookType;
        let imgPath = getGamePath(this.otherProperty.maze.mask.src);
        try {
          this.otherProperty.maze.mask.src = require(`__staticDir/${multibookType}/${imgPath}`);
        } catch (e) {
          console.log(e);
          console.log('Jeżeli to klon, to OK ;)');
        }
        this._addMask();
      }
    }
  }

  stageMouseDown(e, data) {
    console.log('cjsMaze: DOWN');
    console.log(e);
    console.log(data);
    let engine = data.engine,
      stage = data.cjsStage,
      mouse = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY)),
      pt = stage.hero.container.parent.globalToLocal(mouse.x, mouse.y),
      isOk = stage.hero.checkDrawMask(pt, true);
    // console.log(pt);
    // console.log(stage.hero.x + ' ' + stage.hero.y);
    if (isOk === false) {
      e.stopPropagation();
      return;
    }

    let x = stage.hero.x,
      y = stage.hero.y;

    if (
      pt.x > stage.hero.x &&
      pt.x <= stage.hero.x + stage.hero.width &&
      pt.y > stage.hero.y &&
      pt.y < stage.hero.y + stage.hero.height
    ) {
      console.log('INSIDE');
      let isOk = false,
        ix = stage.hero.x,
        iy = stage.hero.y,
        flg = false;
      do {
        flg = false;
        if (
          pt.x <= stage.hero.x + stage.hero.width / 2 &&
          stage.hero.checkDrawMask({ x: pt.x, y: iy }, true) !== false &&
          ix >= pt.x - stage.hero.width / 2
        ) {
          ix--;
          flg = true;
        } else if (
          pt.x > stage.hero.x + stage.hero.width / 2 &&
          stage.hero.checkDrawMask({ x: pt.x + stage.hero.width, y: iy }, true) !== false &&
          ix <= pt.x - stage.hero.width / 2
        ) {
          ix++;
          flg = true;
        }
        if (
          pt.y <= stage.hero.y + stage.hero.height / 2 &&
          stage.hero.checkDrawMask({ x: ix, y: pt.y }, true) !== false &&
          iy >= pt.y - stage.hero.height / 2
        ) {
          iy--;
          flg = true;
        } else if (
          pt.y > stage.hero.y + stage.hero.height / 2 &&
          stage.hero.checkDrawMask({ x: ix, y: pt.y + stage.hero.height }, true) &&
          iy <= pt.y - stage.hero.height / 2
        ) {
          iy++;
          flg = true;
        }
        isOk = stage.hero.checkDrawMask({ x: ix, y: iy }, true);
        if (isOk === false || stage.hero.checkCollision(ix, iy) === false) break;
        x = ix;
        y = iy;
      } while (isOk !== false && flg !== false);
    } else {
      if (pt.x < stage.hero.x) {
        console.log('LEFT');
        for (let i = stage.hero.x; i >= pt.x - stage.hero.width / 2; i--) {
          let isOk = stage.hero.checkDrawMask({ x: i, y: y }, true);
          if (isOk === false || stage.hero.checkCollision(i, y) === false) break;
          x = i;
        }
      } else if (pt.x > stage.hero.x && pt.y > stage.hero.y && pt.y < stage.hero.y + stage.hero.height) {
        console.log('RIGHT');
        for (let i = stage.hero.x; i <= pt.x - stage.hero.width / 2; i++) {
          let isOk =
            stage.hero.checkDrawMask({ x: i, y: y }, true) &&
            stage.hero.checkDrawMask({ x: i + stage.hero.width, y: y }, true);
          if (isOk === false || stage.hero.checkCollision(i, y) === false) break;
          x = i;
        }
      } else if (pt.y < stage.hero.y) {
        console.log('UP');
        for (let i = stage.hero.y; i >= pt.y - stage.hero.height / 2; i--) {
          let isOk = stage.hero.checkDrawMask({ x: x, y: i }, true);
          if (isOk === false || stage.hero.checkCollision(x, i) === false) break;
          y = i;
        }
      } else if (pt.y > stage.hero.y) {
        console.log('DOWN');
        for (let i = stage.hero.y; i <= pt.y - stage.hero.height / 2; i++) {
          let isOk =
            stage.hero.checkDrawMask({ x: x, y: i }, true) &&
            stage.hero.checkDrawMask({ x: x, y: i + stage.hero.height }, true);
          if (isOk === false || stage.hero.checkCollision(x, i) === false) break;
          y = i;
        }
      }
    }

    stage.hero.pos = { x: x, y: y };
    stage.movesTo.push(stage.hero);
    stage.hero.move = true;

    e.stopPropagation();
  }

  checkCollision(x, y) {
    let isOk = false;
    for (let ix = x; ix <= x + this.width; ix++) {
      for (let iy = y; iy <= y + this.height; iy += this.height) {
        isOk = this.checkDrawMask({ x: ix, y: iy }, true);
        if (isOk === false) {
          // console.log('I ix: ' + ix + ' iy: ' + iy);
          return false;
        }
      }
      if (ix === x || ix === x + this.width) {
        for (let iy = y; iy <= y + this.height; iy++) {
          isOk = this.checkDrawMask({ x: ix, y: iy }, true);
          if (isOk === false) {
            // console.log('II ix: ' + ix + ' iy: ' + iy);
            return false;
          }
        }
      }
    }

    return isOk === false ? false : true;
  }

  moveLeft() {
    console.log('LEFT');
    let step = false,
      i = this.steps;
    do {
      step = this.checkCollision(this.x - i, this.y);
      if (step === false) {
        i--;
      }
    } while (i >= 0 && step === false);
    if (step !== false) {
      this.x -= i;
    }

    return step;
  }

  moveRight() {
    console.log('RIGHT');
    let step = false,
      i = this.steps;
    do {
      step = this.checkCollision(this.x + i, this.y);
      if (step === false) {
        i--;
      }
    } while (i >= 0 && step === false);
    if (step !== false) {
      this.x += i;
    }

    return step;
  }

  moveUp() {
    console.log('UP');
    let step = false,
      i = this.steps;
    do {
      step = this.checkCollision(this.x, this.y - i);
      if (step === false) {
        i--;
      }
    } while (i >= 0 && step === false);
    if (step !== false) {
      this.y -= i;
    }

    return step;
  }

  moveDown() {
    console.log('DOWN');
    let step = false,
      i = this.steps;
    do {
      step = this.checkCollision(this.x, this.y + i);
      if (step === false) {
        i--;
      }
    } while (i >= 0 && step === false);
    if (step !== false) {
      this.y += i;
    }

    return step;
  }

  get move() {
    return this._move;
  }
  set move(v) {
    this._move = v;
  }
  get checks() {
    return this._checks;
  }
  set checks(v) {
    this._checks = v;
  }
  get mask() {
    return this._mask;
  }

  get colorFinish() {
    return new jsColor(this.otherProperty.maze.stop);
  }

  // get tolerance() {
  //   return typeof this.otherProperty.maze.tolerance == 'undefined' ||
  //     this.otherProperty.maze.tolerance == null ||
  //     fJS.isNumeric(this.otherProperty.maze.tolerance) == false
  //     ? 0
  //     : this.otherProperty.maze.tolerance;
  // }

  get steps() {
    return typeof this.otherProperty.maze.steps == 'undefined' ||
      this.otherProperty.maze.steps == null ||
      fJS.isNumeric(this.otherProperty.maze.steps) == false ||
      this.otherProperty.maze.steps === 0
      ? 5
      : this.otherProperty.maze.steps;
  }
}

cjsMaze.tick = function (stage) {
  if (typeof stage.hero == 'undefined' || stage.hero.move === false) {
    return;
  }

  let step = false;

  if (stage.keys.left) {
    step = stage.hero.moveLeft();
  } else if (stage.keys.right) {
    step = stage.hero.moveRight();
  } else if (stage.keys.up) {
    step = stage.hero.moveUp();
  } else if (stage.keys.down) {
    step = stage.hero.moveDown();
  }

  if (step !== false || stage.hero.move === true) {
    if (stage.hero.move === true && stage.movesTo.length === 0) {
      stage.hero.move = false;
    }
    if (stage.autoCheckAllCorrect === true && cjsMaze.checkGameAction.call(this, stage) === true) {
      console.log('autoCheckAllCorrect');
      STORE.dispatch('checkGame');
    }
  }
};

cjsMaze.checkGameAction = function (stage) {
  return stage.hero.colorFinish.isSimilar(
    stage.hero.checkDrawMask({ x: stage.hero.x + stage.hero.width / 2, y: stage.hero.y + stage.hero.height / 2 }, true)
  );
};

cjsMaze.beforeDestroy = function (stage) {
  console.log('cjsMaze: beforeDestroy');

  window.removeEventListener('keydown', stage.listener.kd, false);
  window.removeEventListener('keyup', stage.listener.ku, false);
};

cjsMaze.afterLoadSamples = function (stage) {
  cjsItem.afterLoadSamples(stage);
  console.log('cjsMaze afterLoadSamples');
  stage.keys = { left: false, up: false, right: false, down: false };
};

cjsMaze.afterPromises = function (stage) {
  cjsItem.afterPromises(stage);
  console.log('cjsMaze: afterPromises');

  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      if (stage.groups[gr].items[i].block == false) {
        let found = false;
        for (let x = 0; x < stage.groups[gr].items[i]._mask.cacheCanvas.width; x += 5) {
          for (let y = 0; y < stage.groups[gr].items[i]._mask.cacheCanvas.height; y += 5) {
            let imgData = stage.groups[gr].items[i]._mask.cacheCanvas.getContext('2d').getImageData(x, y, 1, 1);
            let color = new jsColor([imgData.data[0], imgData.data[1], imgData.data[2]]);
            if (color.r == 255 && color.g == 0 && color.b == 0) {
              stage.groups[gr].items[i].x = x;
              stage.groups[gr].items[i].y = y;
              stage.groups[gr].items[i]._posStart.x = x;
              stage.groups[gr].items[i]._posStart.y = y;
              found = true;
              break;
            }
          }
          if (found === true) break;
        }
      }
    }
  }
};

cjsMaze.defineKeys = function (stage) {
  console.log('cjsMaze define keys');
  stage.listener.kd = function (e) {
    e = !e ? window.event : e;
    switch (e.keyCode) {
      case KEYS.LEFT:
        stage.keys.left = true;
        stage.hero.move = true;
        break;
      case KEYS.UP:
        stage.keys.up = true;
        stage.hero.move = true;
        break;
      case KEYS.RIGHT:
        stage.keys.right = true;
        stage.hero.move = true;
        break;
      case KEYS.DOWN:
        stage.keys.down = true;
        stage.hero.move = true;
        break;
    }

    e.stopPropagation();
  };

  stage.listener.ku = function (e) {
    e = !e ? window.event : e;
    switch (e.keyCode) {
      case KEYS.LEFT:
        stage.keys.left = false;
        break;
      case KEYS.UP:
        stage.keys.up = false;
        break;
      case KEYS.RIGHT:
        stage.keys.right = false;
        break;
      case KEYS.DOWN:
        stage.keys.down = false;
        break;
    }
    stage.hero.move = false;
    e.stopPropagation();
  };

  window.addEventListener('keydown', stage.listener.kd);
  window.addEventListener('keyup', stage.listener.ku);
};
